import { render, staticRenderFns } from "./SurfaceNavBookmarkButton.vue?vue&type=template&id=18f0ee64&scoped=true&"
import script from "./SurfaceNavBookmarkButton.vue?vue&type=script&lang=ts&"
export * from "./SurfaceNavBookmarkButton.vue?vue&type=script&lang=ts&"
import style0 from "./SurfaceNavBookmarkButton.vue?vue&type=style&index=0&id=18f0ee64&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f0ee64",
  null
  
)

export default component.exports